
const cleanJsonString = (input) => {
    if(input == null) return undefined

    let output = input
    try {
        if(output != null){
            output = output.replace(/(\\{1}.)/g, '')
            output = output.replace(/(\{{1}\{)/g, '"{{')
            output = output.replace(/(\}{1}\})/g, '}}"')
            output = JSON.parse(output)
            return output
        }
    } catch (error) {
        if(process.env.NODE_ENV === 'development'){
            console.log('Unable to clean json string', output)
            console.log(error)
        }

    }
}
export default cleanJsonString